import { createContext, useState, useEffect } from "react";
import { API_URL } from "../shared/constant";
import axios from "axios";
import { NotificationManager } from "react-notifications";
export const SiteContext = createContext({
  setSiteSettings: () => null,
  siteSettings: null,
});

export const SiteProvider = ({ children }) => {
  const [siteSettings, setSiteSettings] = useState(null);
  const value = { siteSettings };
  const getSiteSettings = async () => {
    return await axios
      .get(API_URL.SITE_SETTING)
      .then((res) => {
        if (res.data.code === 200) {
          setSiteSettings(res.data.data);
        }
      })
      .catch((err) => {
        NotificationManager.error("Failed to connect server!.");
      });
  };

  useEffect(() => {
    getSiteSettings();
  }, []);

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};
